import { render } from "./OrderService.vue?vue&type=template&id=77980f18&scoped=true"
import script from "./OrderService.vue?vue&type=script&lang=js"
export * from "./OrderService.vue?vue&type=script&lang=js"

import "./OrderService.vue?vue&type=style&index=0&id=77980f18&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77980f18"]])

export default __exports__